import React, { useState } from "react";
import { makeStyles, InputAdornment, IconButton, TextField, Tooltip } from "@material-ui/core";
import { LIGHT_GRAY_COLOR, SHADOW_GRAY_COLOR } from "../../theme";
import TextFieldIconSeparator from "./TextFieldIconSeparator";
import { Search, X } from "react-feather";

const TextFieldPesquisa = (props) => {
    const {
        id,
        label,
        value,
        onChange,
        className,
        autoFocusEnable,
        iconeSeparador,
        alterarIconeHover,
        autoComplete
    } = props;

    const [hoverIcone, setHoverIcone] = useState(false);

    const classes = useStyles();

    return (
        <TextField
            autoFocus={!autoFocusEnable ? false : autoFocusEnable}
            className={"largura-maxima " + className}
            id={id}
            value={value}
            label={label}
            variant='outlined'
            disabled={false}
            onChange={onChange}
            autoComplete={autoComplete}
            InputLabelProps={{
                style: {
                    color: SHADOW_GRAY_COLOR
                }
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position='end'>
                        {alterarIconeHover ? (
                            <IconButton
                                className={classes.iconButton}
                                aria-label='Clear'
                                onClick={() => onChange({ target: { value: "" } })}
                                onMouseEnter={() => setHoverIcone(true)}
                                onMouseLeave={() => setHoverIcone(false)}
                            >
                                {hoverIcone && value.length ? <Tooltip title="Limpar pesquisa"><X size={20} /></Tooltip> : <Search size={16} />}
                            </IconButton>
                        ) : (
                            value.length ? (
                                <Tooltip title="Limpar pesquisa">
                                    <IconButton
                                        className={classes.iconButton}
                                        aria-label='Clear'
                                        onClick={() => onChange({ target: { value: "" } })}
                                    >
                                        <X size={20} />
                                    </IconButton>
                                </Tooltip>
                            ) : null
                        )}

                        {iconeSeparador &&
                            <TextFieldIconSeparator />
                        }

                        {!alterarIconeHover &&
                            (<IconButton className={classes.iconButton} aria-label='Search'>
                                <Search size={16} />
                            </IconButton>)
                        }
                    </InputAdornment>
                ),
                classes: {
                    notchedOutline: classes.notchedOutline,
                    adornedEnd: classes.adornedEnd
                }
            }}
        />
    );
};

const useStyles = makeStyles((theme) => ({
    notchedOutline: {
        borderColor: LIGHT_GRAY_COLOR
    },
    adornedEnd: {
        paddingRight: "2px"
    },
    iconButton: {
        color: SHADOW_GRAY_COLOR,
    }
}))

export default TextFieldPesquisa;